import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';

const useStates = (options = {}) => {
  const { loading, data } = useQuery(Queries.getW4States, options);
  return { loading, data: data && data.getW4States };
};

export default useStates;
